import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";

import { CcStepper2 } from "../commonComponents/stepper"
import { InputText, InputTextPassword } from "../commonComponents/inputFields";
import { CcActionButton } from "../commonComponents/styledTexts";
import { LionLoader, LionLoaderBig, LionLoaderSmall } from "../commonComponents/generalComponents";

import { object as yupObject, string, } from 'yup';
import { getErrorListFromYupError, getErrorMessage } from '../components/helperErrors';

import axios from 'axios';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import "./stripe.css";
import { ccColorDarkTeal, ccColorTeal } from "../components/helpersStyles";
import { Icon as Iconify } from '@iconify/react';
import { ActivateSubscriptionForm } from "./newUserWorkflow";
import StatCard from "./components/StatCard";
import FeatureItem from './components/FeatureItem'
import {AtSign, 
  BarChart3,
  Building2,
  CalendarDays,
  Check,
  CreditCard,
  Image as ImageIcon,
  Lock, LockKeyhole,
  Mail,
  MousePointer2,
  Plug,
  ShoppingCart,
  TrendingUp,
  User,
  Zap,
} from 'lucide-react'
import { lionIcons } from "../components/helpersIcons";

const features = [
  {
    icon: <LockKeyhole size={44} strokeWidth={1.8} />,
    title: 'Full platform access',
    description: 'Try every element. No limitations or paywalls.',
    tone: 'text-ccColorSecondaryPink',
  },
  {
    icon: <ImageIcon size={44} strokeWidth={1.8} />,
    title: '1000 free test images',
    description: 'Test and explore with 1000 free images on us.',
    tone: 'text-ccColorSecondaryBronze',
  },
  {
    icon: <CreditCard size={44} strokeWidth={1.8} />,
    title: 'No credit card required',
    description: 'Sign up today risk-free & card-free',
    tone: 'text-ccColorTeal',
  },
  {
    icon: <Plug size={44} strokeWidth={1.8} />,
    title: 'ESP agnostic',
    description: 'We work with every email service provider.',
    tone: 'text-ccColorSecondaryPurple',
  },
  {
    icon: <TrendingUp size={44} strokeWidth={1.8} />,
    title: 'Better results',
    description: 'More clicks, engagement & revenue.',
    tone: 'text-ccColorSecondaryGreen',
  },
  {
    icon: <Zap size={44} strokeWidth={1.8} />,
    title: 'Quick & easy to launch',
    description: "Design, copy + paste, send. It’s that simple",
    tone: 'text-ccColorSecondaryAzure',
  },
  {
    icon: <CalendarDays size={44} strokeWidth={1.8} />,
    title: 'Flexible plans',
    description: 'Monthly, Annual, Peak Packages or project specific.',
    tone: 'text-ccColorOrange',
  },
]


const emailString = string().email();
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);



export const NewUserWorkflow2 = (props) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [email, setEmail] = useState("")
    const [emailExistsMsg, setEmailExistsMsg] = useState("")
    const [businessName, setBusinessName] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [firstname, setFirstname] = useState("")
    const [surname, setSurname] = useState("")

    const [loginName, setLoginName] = useState("")
    const [loginNameExistsMsg, setLoginNameExistsMsg] = useState(null)
    const [clientSecret, setClientSecret] = useState(undefined)
    const [isValidPlan, setIsValidPlan] = useState(false)
    const [planInfo, setPlanInfo] = useState(undefined)
    const [freeLoginSuccess, setFreeLoginSuccess] = useState(false)

    const [activeErrorList, setActiveErrorList] = useState([]);

    const [showLoaderProductInfo, setShowLoaderProductInfo] = useState(true)
    const [showLoaderUserForm, setShowLoaderUserForm] = useState(false)
    const [showLoaderUserFormFreeTrial, setShowLoaderUserFormFreeTrial] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const URLparams = new URLSearchParams(document.location.search);
    const plan = URLparams.get("plan");
    const trialOffer = URLparams.get("trial");
    
    const URL_PRICING_PAGE = "https://codechemistry.io/pricing/" 

    
    useEffect(() => {
      //check for a valid plan name
      if (plan !== null) {
        checkProductIsValid(plan);
      }
      else {
        setIsValidPlan(false)
        setShowLoaderProductInfo(false)
      }
    }, [plan])

    let options = {
      // passing the SetupIntent's client secret
      //clientSecret: '{{CLIENT_SECRET}}',
      clientSecret: clientSecret,
      // Fully customizable with appearance API.
      appearance: {
      
        variables: {
          colorPrimary: ccColorDarkTeal,
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Roboto, Poppins, Ideal Sans, system-ui, sans-serif',
          spacingUnit: '2px',
          borderRadius: '4px',
          // See all possible variables below
        }
      },
    };
    
    const userFormValidationSchema = yupObject({
      businessName: string().required("Required field"),
      firstname: string().required("Required field"),
      surname: string().required("Required field"),
      loginName: string().required("Required field").matches(/^(?!.*@).*$/,{message: "Must not contain the @ character"}).min(6, "Must be at least 6 characters long"),
      password: string().required("Required field").min(8, "Must be at least 8 characters long"),
      confirmPassword: string().test(
        'validatePassword',
        '',
        (value, context) => {
          if (value === '' || value !== context.parent.password)
            return context.createError({path: 'confirmPassword', message: "Passwords don't match"});
          else return true;
        }
      )
    });

    const createUserFormDataObject = () => {
      return {businessName: businessName, loginName: loginName, password: password, confirmPassword: confirmPassword, firstname: firstname, surname: surname}
    }
    const validateUserForm = (formData) => {
      let result = false;
      try {
        userFormValidationSchema.validateSync(formData, {abortEarly: false});
        setActiveErrorList([])
        result = true;
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        //console.log(errorList)
        setActiveErrorList(errorList)
        result = false;
      }
      if (email === '') {
        setEmailExistsMsg("Email is required")
        result = false;
      }

      return result;
    }

    const handleEmailChange = (newEmail) => {
        setEmail(newEmail)
        const isValidEmail = emailString.isValidSync(newEmail);
        if (isValidEmail) {
          checkEmailExists(newEmail)
        }
      }
    
    const checkEmailExists = async (email) => {
      if (email === '') {
        setEmailExistsMsg("Email is required")
        return;
      }
    try {
        const url = `${process.env.REACT_APP_LION_API_URL}/email/exists/${email}`;
        const response = await axios.get(url);

        if (response.data === true) setEmailExistsMsg("This email already exists")
        else setEmailExistsMsg("")

    return response.data;
                
    } catch (error) {
        console.log(error);
    }
    }
    
    const handleLoginChange = (newLogin) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.loginName = newLogin;

        if (activeErrorList.length > 0) validateUserForm(objToValidate)
        setLoginName(newLogin)
        if (newLogin.length >= 6) {
            checkLoginExists(newLogin)
        }
      }
    const handleBusinessNameChange = (newName) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.businessName = newName
      if (activeErrorList.length > 0) validateUserForm(objToValidate)

        setBusinessName(newName)
    }
    const handleFirstnameChange = (newName) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.firstname = newName
      if (activeErrorList.length > 0) validateUserForm(objToValidate)

        setFirstname(newName)
    }
    const handleSurnameChange = (newName) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.surname = newName
      if (activeErrorList.length > 0) validateUserForm(objToValidate)

        setSurname(newName)
    }

    const handleConfirmPasswordChange = (newName) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.confirmPassword = newName
      //if (activeErrorList.length > 0) validateUserForm(objToValidate)
      validateUserForm(objToValidate)

        setConfirmPassword(newName)
    }
    const handlePasswordChange = (newName) => {
      const objToValidate = createUserFormDataObject()
      objToValidate.password = newName
      if (activeErrorList.length > 0) validateUserForm(objToValidate)

        setPassword(newName)
    }

    const checkLoginExists = async (login) => {
        try {
            const url = `${process.env.REACT_APP_LION_API_URL}/email/login/exists/${login}`;
            const response = await axios.get(url);
            if (response.data === true) setLoginNameExistsMsg("This login already exists")
            else setLoginNameExistsMsg(null)
    
        return response.data;
                    
        } catch (error) {
            console.log(error);
        }    
    }

    const checkProductIsValid = async(prodId) => {
      try {
          setShowLoaderProductInfo(true)
          const url = `${process.env.REACT_APP_LION_API_URL}/stripe/product/isvalid/${prodId}`;
          const response = await axios.get(url);
  
          const isValid = response.data.isValid;
          setIsValidPlan(isValid)
          if (isValid) setPlanInfo(response.data.product)
          else setPlanInfo(undefined)
      } catch (error) {
          return false;
      }
      finally {setShowLoaderProductInfo(false)}

  }

  const submitCreateUser = async() => {
    
    const objToValidate = createUserFormDataObject()
    const isValidForm = validateUserForm(objToValidate);

    if (!isValidForm) return;


    try {
      setShowLoaderUserForm(true)
      setShowLoaderUserFormFreeTrial(true)
      setErrorMessage("")
        //const url = `${process.env.REACT_APP_LION_API_URL}/create-new-user`;
        const url = `${process.env.REACT_APP_LION_API_URL}/stripe/create-new-user-with-subscription`;
        const response = await axios.post(url, {subscriptionPlan: plan, trialOffer: trialOffer, email: email, name: loginName, businessName: businessName, password: password, firstname: firstname, surname: surname});

        //if (response.data === true) setLoginNameExistsMsg("This login already exists")
        //else setLoginNameExistsMsg("")
        if (response.data.error) {
          if (response.data.field === "email") setEmailExistsMsg(response.data.error);
          else setErrorMessage(response.data.error);
          return;
        }
        if (response.data.loginType === "free") {
          //it's a free login
          setFreeLoginSuccess(response.data.success)
        }
        else {
          options.clientSecret = response.data.clientSecret;
          setClientSecret(response.data.clientSecret)
        }

        setCurrentStepIndex(1);
        //console.log(options);
                
    } catch (error) {
        //console.log(error);
        setErrorMessage("Oops something went wrong");
    }
    finally {setShowLoaderUserForm(false); setShowLoaderUserFormFreeTrial(false)}

    }

    const runGAScript = () => {
      window.dataLayer = window.dataLayer || [];
      console.log(window.dataLayer)
      window.dataLayer.push({
         event: 'free_trial_submit'
         });
    }

    return <div style={{backgroundSize: 'cover', minHeight: 'calc(100vh - 20px)',}}>
        <Helmet>
            {/* Adding GA  */}
            <script>{`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], 
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-PQ673Q6K');
          `}</script>
        </Helmet>

          <div className='flex flex-row items-center w-full gap-20 font-poppins bg-gradient-to-r from-ccColorDarkTeal to-ccColorTeal'>
            <img src='/assets/logoWhite.png' className=' h-20 w-auto ml-8' alt='logo'/>
         </div>

    {errorMessage.length > 0 && <div className="flex flex-col items-center justify-center mt-1">
          <div class="w-96 flex p-4 mb-0 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800" role="alert">
                <div className="flex gap-x-2">
                    <span class="font-semibold">Error</span> 
                    <div>{errorMessage}</div>
                </div>
            </div>
          </div>
    }
      {showLoaderProductInfo &&
        <div className="mt-16">
        <LionLoaderBig />
        <div className=" mt-2 flex justify-center text-ccColorDarkTeal ">Loading product data...</div>
      </div>
      }
    
    {isValidPlan && !showLoaderProductInfo &&
          <div className=" mx-[10%]">
                <CcStepper2
                steps={[{ name: 'Create account', href: '#' },
                        { name: 'Payment options', href: '#' },
                    ]}
                currentStepIndex={currentStepIndex}
                />

    <div className="grid grid-cols-2">
      {currentStepIndex === 0 && !showLoaderUserForm &&
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
              <div className=" sm:mx-auto sm:w-full sm:max-w-sm">
                <h2 className="font-poppins text-center text-2xl font-bold leading-9 tracking-tight text-ccColorDarkTeal">
                  Create an account
                </h2>
              </div>

              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputText displayName="Firstname" 
                        value={firstname}
                        onChange={handleFirstnameChange}
                        error={getErrorMessage(activeErrorList, 'firstname')}
                  />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputText displayName="Surname" 
                        value={surname}
                        onChange={handleSurnameChange}
                        error={getErrorMessage(activeErrorList, 'surname')}
                  />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputText displayName="Business email" 
                        value={email}
                        onChange={handleEmailChange}
                        error={emailExistsMsg}
                  />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputText displayName="Business name" 
                        value={businessName}
                        onChange={handleBusinessNameChange}
                        error={getErrorMessage(activeErrorList, 'businessName')}
                        />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputText displayName="Username" 
                        value={loginName}
                        onChange={handleLoginChange}
                        error={loginNameExistsMsg ?? getErrorMessage(activeErrorList, 'loginName')}
                  />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputTextPassword displayName="Password" 
                        value={password}
                        onChange={handlePasswordChange}
                        error={getErrorMessage(activeErrorList, 'password')}
                  />
              </div>
              <div className="sm:mx-auto sm:w-full sm:max-w-sm mt-5">
                  <InputTextPassword displayName="Confirm Password" 
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        error={getErrorMessage(activeErrorList, 'confirmPassword')}
                  />
              </div>
              <div className="mt-3 max-w-sm mx-auto font-poppins text-xs tracking-tight text-gray-900">
                  By creating an account, you agree to our <a href="https://codechemistry.io/terms-conditions/" target="_blank" rel='noreferrer' class="font-medium text-ccColorTeal hover:underline">Terms</a> and have read and acknowledged our <a href="https://codechemistry.io/privacy-policy/" target="_blank" rel='noreferrer' class="font-medium text-ccColorTeal hover:underline">Privacy Policy</a> 
                </div>

              <div className=" mx-auto w-full max-w-sm mt-6">
                    <CcActionButton className=" w-full flex justify-center"
                    onClick={submitCreateUser}
                    >
                      Next
                    </CcActionButton>
              </div>

            </div>      
      }
      {currentStepIndex === 0 && showLoaderUserForm &&
      <div className="flex flex-col justify-center items-center">
        <LionLoader />
        <div className="mt-2 text-ccColorDarkTeal">Creating account</div>
      </div>
      }
      {currentStepIndex === 1 && clientSecret &&
      <div>
            <Elements stripe={stripePromise} options={options}>
      <ActivateSubscriptionForm customerFirstname={firstname} />
    </Elements>
      </div>
        
      }
      <div className="mt-[58px] flex flex-col gap-6 items-center font-poppins">
        <div className=" text-2xl font-bold text-ccColorDarkTeal">{planInfo.metadata.title ? planInfo.metadata.title : planInfo.productName}</div>
        <div style={{color: planInfo.metadata.textColor}} className=" text-2xl  mt-2">{planInfo.metadata.price}</div>
        {JSON.parse(planInfo.metadata.features).map(f => <div className=" text-ccColorDarkTeal font-semibold">{f}</div>)}
        <div className="mt-2">Thinking of a different plan? <a href={URL_PRICING_PAGE} class="font-medium text-ccColorTeal hover:underline">Click here to view other options</a></div>
      </div>
    </div>
    </div>
    }
    {!isValidPlan && !showLoaderProductInfo &&
          <div className="">
      {currentStepIndex === 0 && <div className="">
            <div className="md:px-8 grid grid-cols-1 md:grid-cols-2 font-inter">
                <div className="pt-6 pl-8">
                <h1 className="max-w-[650px] text-5xl font-extrabold leading-[1.04] tracking-tight text-ccColorDarkTeal sm:text-6xl">
                    Get more from<br />
                    your current opens.<br />
                    <span className="hero-squiggle text-ccColorTeal">Turn opens into<br />engagement.</span>
                </h1>
                <p className="mt-10 max-w-[540px] text-lg leading-8 text-slate-600">
                    Add interactive and dynamic elements to your emails in minutes. No coding needed.
                    <br />Design your element. Copy & paste it into your email.
                </p>

                <div className="mt-12 grid gap-8 sm:grid-cols-3 place-content-center md:place-items-start">
                    <StatCard
                    icon={<BarChart3 size={42} strokeWidth={1.8} />}
                    value="192%"
                    title="more revenue"
                    description="with Code Chemistry elements"
                    tone="text-ccColorSecondaryPink"
                    />
                    <StatCard
                    icon={<MousePointer2 size={42} strokeWidth={1.8} />}
                    value="+150%"
                    title="higher CTR"
                    description="with interactive elements"
                    tone="text-ccColorOrange"
                    />
                    <StatCard
                    icon={<ShoppingCart size={42} strokeWidth={1.8} />}
                    value="200%"
                    title="more orders"
                    description="driven by interactive email content"
                    tone="text-ccColorTeal"
                    />
                </div>
                </div>

                <div className="flex min-h-full flex-1 flex-col justify-center px-6 pt-12 pb-8 lg:px-8">
                  <div className="relative rounded-2xl ring-1 ring-slate-200 w-fit px-8 bg-white">
                      <div className="absolute right-[-48px] -z-50 -top-8 h-80 w-80 rounded-full bg-ccColorTeal/90" />
                      <div className="absolute right-[-32px] -z-50 top-72 h-32 w-32 rounded-full bg-amber-400" />

                      <div className="sm:w-full sm:max-w-sm">
                      <h2 className="mt-3 font-poppins text-2xl font-bold leading-9 tracking-tight text-ccColorDarkTeal">
                          Create your free trial account
                      </h2>
                      </div>
                      <div className="w-fit  justify-center text-sm mx-auto mt-4 font-poppins"><div className="text-sm">Full access to all features for 7 days. No credit card required.</div></div>

                      <div className="sm:mx-auto sm:w-full mt-5">
                              <InputText //displayName="Firstname" 
                                      value={firstname}
                                      placeHolder='First name'
                                      placeHolderIcon={<User />}
                                      onChange={handleFirstnameChange}
                                      error={getErrorMessage(activeErrorList, 'firstname')}
                              />
                      </div>
                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputText //displayName="Surname" 
                              placeHolder='Last name'
                              placeHolderIcon={<User />}
                              value={surname}
                              onChange={handleSurnameChange}
                              error={getErrorMessage(activeErrorList, 'surname')}
                          />
                      </div>

                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputText //displayName="Business email" 
                              placeHolder='Work email'
                              placeHolderIcon={<Mail />}
                              value={email}
                              onChange={handleEmailChange}
                              error={emailExistsMsg}
                          />
                      </div>
                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputText //displayName="Business name"
                              placeHolder='Company name'
                              placeHolderIcon={<Building2 />}
                              value={businessName}
                              onChange={handleBusinessNameChange}
                              error={getErrorMessage(activeErrorList, 'businessName')}
                              />
                      </div>
                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputText //displayName="Username"
                              placeHolder='Username'
                              placeHolderIcon={<AtSign />}
                              value={loginName}
                              onChange={handleLoginChange}
                              error={loginNameExistsMsg ?? getErrorMessage(activeErrorList, 'loginName')}
                              />
                      </div>
                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputTextPassword //displayName="Password"
                              placeHolder='Password'
                              placeHolderIcon={<Lock />}
                              value={password}
                              onChange={handlePasswordChange}
                              error={getErrorMessage(activeErrorList, 'password')}
                          />
                      </div>
                      <div className="sm:mx-auto sm:w-full mt-5">
                          <InputTextPassword //displayName="Confirm Password" 
                                  value={confirmPassword}
                                  placeHolder='Confirm password'
                                  placeHolderIcon={<Lock />}
                                  onChange={handleConfirmPasswordChange}
                                  error={getErrorMessage(activeErrorList, 'confirmPassword')}
                          />
                      </div>

                      <div className=" mx-auto w-full mt-6">
                          <CcActionButton className=" w-full flex justify-center"
                          onClick={submitCreateUser}
                          >
                              {showLoaderUserFormFreeTrial ? 
                                      <LionLoaderSmall />
                                      :
                                      <>Create</>
                              }
                          </CcActionButton>
                      </div>
                      <div className="mt-6 mb-10 max-w-sm mx-auto font-poppins text-xs tracking-tight text-gray-900">
                          By signing up, you agree to our <a href="https://codechemistry.io/terms-conditions/" target="_blank" rel='noreferrer' class="font-medium text-ccColorTeal hover:underline">Terms of service</a> and <a href="https://codechemistry.io/privacy-policy/" target="_blank" rel='noreferrer' class="font-medium text-ccColorTeal hover:underline">Privacy Policy</a> 
                      </div>

                  </div>
                  <div className="mt-1 ml-3 md:ml-12 font-inter text-slate-600">
                    Find out more about our pricing and plans <a className="font-semibold" href="https://codechemistry.io/pricing/">here.</a>
                  </div>
                </div>
            </div>


        <section className="py-1 px-8 md:py-4 bg-ccColorLightTeal bg-opacity-20">
          <div className="container-page grid items-center gap-12 lg:grid-cols-[1.3fr_.7fr]">
            <div className="relative">
              <div className="absolute -left-8 -top-8 h-24 w-24 rounded-full bg-fuchsia-300/30" />
              <img
                src="/assets/signup/2/dashboard-preview.png"
                alt="Code Chemistry product dashboard"
                className="relative w-full rounded-xl shadow-soft ring-1 ring-slate-200"
              />
            </div>
            <div>
              <h2 className="text-4xl font-extrabold leading-tight text-navy">
                Everything you need.<br />
                <span className="text-ccColorTeal">In just a few clicks.</span>
              </h2>
              <p className="mt-6 mr-28 text-lg leading-8 text-slate-600">
                From interactive elements to personalisation and gamification, Code Chemistry has all the tools you need to create emails that get clicked.
              </p>
              <ul className="mt-7 space-y-4 text-base text-slate-700">
                {['Interactive elements', 'Timers and Relevancy', 'Easy Image Personalisation', 'Easy to use & Implement'].map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <Check className="text-teal" size={20} strokeWidth={3} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="py-1 px-8 md:py-4">
          <div className="container-page">
            <h2 className="text-4xl font-extrabold leading-tight text-ccColorDarkTeal">
              Why email marketers choose<br />Code Chemistry
            </h2>
            <div className="mt-12 grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-4 lg:grid-cols-7">
              {features.map((feature) => <FeatureItem key={feature.title} {...feature} />)}
            </div>
          </div>
        </section>

        <section className="pb-10 px-8">
          <div className="container-page relative overflow-hidden rounded-2xl bg-gradient-to-r from-ccColorDarkTeal to-ccColorTeal px-8 py-10 text-white lg:px-12">
            <img src="/assets/signup/2/dots.svg" alt="" className="absolute -right-8 bottom-[-24px] w-28 opacity-55" />
            <div className="relative grid items-center gap-10 lg:grid-cols-[1.3fr_1fr]">
              <div>
                <blockquote className="flex flex-col w-fit">
                  <div className="text-6xl font-extrabold leading-none text-ccColorSecondaryPink">“</div>
                  <div>
                    <p className="max-w-[530px] text-xl leading-8">
                      We found the Code Chemistry platform incredibly easy to use. You just log in, choose your interactive element, and follow a few simple steps. Then, it’s a quick copy-paste into your email HTML. The results speak for themselves - notable uplift, easy execution.
                    </p>
                    <footer className="mt-5 text-sm font-semibold">
                      Bensons for Beds<br />
                      {/*<span className="font-normal text-white/75">CRM Manager, Fashion Retailer</span>*/}
                    </footer>
                  </div>
                  <div className=" text-right text-6xl font-extrabold leading-none text-ccColorSecondaryPink">”</div>
                </blockquote>
              </div>
              <div className="grid lg:grid-cols-3 divide-x divide-white/30 text-center">
                <div className="px-4">
                  <div className="text-3xl font-extrabold text-ccColorSecondaryPink">192%</div>
                  <div className="mt-2 text-sm">more revenue</div>
                </div>
                <div className="px-4 mt-8 lg:mt-0">
                  <div className="text-3xl font-extrabold text-ccColorSecondaryPink">+150%</div>
                  <div className="mt-2 text-sm">CTR</div>
                </div>
                <div className="px-4 mt-8 lg:mt-0">
                  <div className="text-3xl font-extrabold text-ccColorSecondaryPink">200%</div>
                  <div className="mt-2 text-sm">more orders</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-1 px-8">
          <div className="container-page grid items-center gap-8 md:grid-cols-[170px_1fr_auto]">
            <img src="/assets/signup/2/envelope-cta.svg" alt="" className="mx-auto w-40" />
            <div>
              <h2 className="text-4xl font-extrabold leading-tight text-ccColorDarkTeal">
                Ready to turn your opens<br/> into more engagement?
              </h2>
              <p className="mt-3 text-lg text-slate-600">
                We’re the conversion uplift layer between your ESP and your customer. <br/> Sign up to our platform today and start getting more from your emails. 
              </p>
            </div>
            <div className="text-center md:text-right">
              <button className="rounded-lg bg-ccColorSecondaryPink px-10 py-4 font-bold text-white shadow-lg shadow-ccColorSecondaryPink/20 transition hover:-translate-y-0.5"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                Create Account Today or Start my free trial
              </button>
              <p className="mt-4 text-xs text-slate-500">Full access for 7 days. No credit card required.</p>
            </div>
          </div>
        </section>

      </div>
      }
      {currentStepIndex === 1 && 
      <div>
        {freeLoginSuccess && <div className="flex flex-col items-center justify-center mt-10">
            <div class="w-96 flex items-center justify-center p-4 mb-4 text-green-800 border border-green-300 rounded-lg bg-green-50">
                <div className="flex flex-col">
                    <div className=" mb-2 font-semibold">Success</div>                    
                </div>
            </div>
            <div class="w-96 flex items-center justify-center p-4 mb-4 border border-gray-200 rounded-lg">
                <div className="flex flex-col text-ccColorDarkTeal">
                    <div className=" mb-2">Your account is set up. Please verify your email address and then login.</div>
                </div>
            </div>
            {runGAScript()}
          </div>}
        {!freeLoginSuccess && <div className="flex flex-col items-center justify-center mt-10">
          <div class="w-96 flex p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800" role="alert">
                <div className="flex gap-x-2">
                    <span class="font-semibold">Error</span> 
                    <div>Something went wrong, please try again.</div>
                </div>
            </div>
            <div class="w-96 flex items-center justify-center p-4 mb-4 border border-gray-200 rounded-lg">
                <div className="flex flex-col">
                    <button className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                     onClick={() => window.location.reload()}>Go back</button>
                    
                </div>
            </div>

          </div>}
      </div>
        
      }

            </div>}
    </div>
}